//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";

export default {
	name: "SearchHeader",
	computed: {
		...mapGetters([
			"searchTerm",
			"sortProperty"
		]),
		term: {
			get() {
				return this.searchTerm
			},
			set(val) {
				this.setStateValue(["searchTerm", val])
			}
		},
		sort: {
			get() {
				return this.sortProperty
			},
			set(val) {
				this.setStateValue(["sortProperty", val])
			}
		},
	},
	methods: {
		...mapMutations([
			"setStateValue",
			"filterContacts",
			"sortContacts",
		]),
		sortCards() {
			this.sortContacts(this.sort);
		},
		search() {
			this.filterContacts(this.term.toLowerCase());
			this.sortCards();
		},
		reset() {
			this.term = "";
			this.search();
		},
	},
	created() {
		if (this.$root.sortProperty) this.sort = this.$root.sortProperty;
		else this.sort = "firstName";
		this.sortCards();
	},
}
